import React, { useState } from "react";
import styles from "./Checkbox.module.css";

type CheckboxProps = {
  clickHandler?: (checked: boolean) => void;
  color?: string;
  value?: boolean;        // if provided -> controlled
  disabled?: boolean;
  children?: React.ReactNode;
};

const Checkbox = ({ clickHandler, color, value, disabled, children }: CheckboxProps) => {
  const isControlled = value !== undefined;
  const [internal, setInternal] = useState(false);

  const checked = isControlled ? !!value : internal;

  const toggle = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (disabled) return;
    const next = !checked;
    if (!isControlled) setInternal(next);
    clickHandler?.(next);                 // only on user action
  };

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={`${styles.container} ${checked ? styles.checked : ""} ${disabled ? styles.disabled : ""}`}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") toggle(e);
      }}
      style={checked ? { backgroundColor: color } : undefined}
    >
      {children ? children : <img src="/img/tick.svg" alt="" />}
    </div>
  );
};

export default Checkbox;
